import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	inject,
	Input,
	Output,
} from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { AuTechnoBtnComponent } from '@app/shared/ui-components/au-techno-btn/au-techno-btn.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'edit-section-name-modal',
	templateUrl: './edit-section-name-modal.component.html',
	styleUrls: ['./edit-section-name-modal.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatIconModule,
		MatButtonModule,
		MatRippleModule,
		MatDatepickerModule,
		AuTechnoBtnComponent,
		MatDialogModule,
		NgxTolgeeModule,
	],
})
export class EditSectionNameModalComponent {
	@Output() closeEmitted = new EventEmitter<void>();
	@Output() saveEmitted = new EventEmitter<{ value: string; pk: string }>();
	private readonly fb = inject(FormBuilder);
	myForm = this.fb.group({
		name: ['', [Validators.required, Validators.maxLength(100)]],
	});
	private dataValue: {
		name: string;
		pk: string;
	} = { name: '', pk: '' };

	@Input() set data(data: { name: string; pk: string }) {
		this.dataValue = data;
		this.myForm.patchValue({ name: data.name });
	}

	submit() {
		if (this.myForm.valid) {
			this.saveEmitted.emit({
				value: this.myForm.value.name,
				pk: this.dataValue.pk,
			});
			this.closeEmitted.emit();
		}
	}

	closeClicked() {
		this.closeEmitted.emit();
	}
}
